import type { TEducation } from 'constants/dictionaries';

import type { TCustomerUpdateData } from 'shared/types/TCustomerService';

export class Education {
  static EDUCATION_MAP: Record<TEducation, TCustomerUpdateData['education']> = {
    Primary: 'Primary',
    SecondHigher: 'SecondHigher',
    SecondarySpecial: 'SecondarySpecial',
    IncompleteHigher: 'IncompleteHigher',
    Higher: 'Higher',
    AcademicDegree: 'AcademicDegree',
  } as const;

  constructor(private readonly eduction: ICustomSelectValue | undefined | null) {
    // eslint-disable-next-line no-empty-function
  }

  private educationValueToCustomerAdapter = (value: string | undefined | null): TCustomerUpdateData['education'] => {
    return Education.EDUCATION_MAP[value as keyof typeof Education.EDUCATION_MAP] || Education.EDUCATION_MAP.Primary;
  };

  map() {
    return this.educationValueToCustomerAdapter(this.eduction?.value?.toString());
  }
}
